import * as React from "react";
import "../../components/spinner/spinner.scss";
import { auth } from "../../firebase";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useUserAuth } from "../../context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import SpinnerLoading from "../../components/spinner/SpinnerLoading";
import { CircularProgress, Link } from "@mui/material";
import { useEffect } from "react";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://wishallbook.com/">
        WishallBook
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const Login = () => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [isLoading, setLoading] = React.useState(false);
  const [initialLoading, setInitialLoading] = React.useState(true);
  const { logIn } = useUserAuth();
  const naviagte = useNavigate();
  const [user, setUser] = React.useState(null);

  useEffect(()=>{
    document.title = 'Wishallbook Login Page'
  },[])
  const mapStrings = (errorCode) => {
    switch (errorCode) {
      case "auth/invalid-email":
        return "Please enter a valid email address.";
      case "auth/missing-password":
        return "Please enter a password.";
      case "auth/user-not-found":
        return "Invalid credentials";
      case "auth/wrong-password":
        return "The password entered is incorrect.";
      // Add more cases as needed
      default:
        return "Something went wrong. Please try again."; // Return the original string if no match
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrorMessage("");
    const isValid = /\b@pareeksha\.com$/.test(email);

    if (isValid) {
      setLoading(true);

      try {
        await logIn(email, password);
        naviagte("/");
      } catch (err) {
        const errorCode = err.code;
        const errorMessage = mapStrings(errorCode);
        setErrorMessage(errorMessage);
        setLoading(false);
      }
    } else {
      setErrorMessage("Not Authorized to this website.");
    }
  };
  const handlePasswordInput = (e) => {
    setErrorMessage("");
    setPassword(e.target.value);
  };
  const handleEmailInput = (e) => {
    setErrorMessage("");
    setEmail(e.target.value);
  };

  React.useEffect(() => {
    const unsubsribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      localStorage.setItem("isLoggedIn", currentUser);
      setInitialLoading(false);
    });

    return () => {
      unsubsribe();
    };
  }, []);

  if (user) {
    return <Navigate to="/" />;
  }


  return (
    <>
      {initialLoading && <SpinnerLoading />}
      {!initialLoading && !user && (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "black" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in to Wishallbook Admin Panel
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1 }}
            >
              <TextField
                error={errorMessage.length === 0 ? false : true}
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                value={email}
                onChange={handleEmailInput}
                autoFocus
              />
              <TextField
                error={errorMessage.length === 0 ? false : true}
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={handlePasswordInput}
                helperText={errorMessage}
              />
              <Box sx={{ position: "relative" }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  disabled={isLoading}
                 
                >
                  Sign In
                </Button>
                {isLoading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: "-12px",
                      marginLeft: "-12px",
                    }}
                  />
                )}
              </Box>
              
            </Box>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Container>
      )}
    </>
  );
};

export default Login;
